import React, { Component } from 'react'
// import PropTypes from 'prop-types'
// import {
//   Link,
//   Route
// } from 'react-router-dom'


import './signin_form.css'

class Projects extends Component {
  render() {

    const { match } = this.props;

    console.warn('match', match)
    return (
      <div className="content">
        login will go here someday
      </div>
    )

  }
}

export default Projects



// WEBPACK FOOTER //
// ./src/components/Login/index.js